var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilePhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6051",
    "data-name": "Group 6051",
    transform: "translate(0.023 0.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2582",
    "data-name": "Rectangle 2582",
    transform: "translate(-0.023 -0.047)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Call",
    "data-name": "Iconly/Bold/Call",
    transform: "translate(7.977 7.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Call",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Call-2",
    "data-name": "Call",
    d: "M11.469,8.782a1.617,1.617,0,0,0-1.187.312c-.342.2-.992.726-1.364.591a8.465,8.465,0,0,1-4.478-4.37c-.137-.381.388-1.035.586-1.381a1.657,1.657,0,0,0,.31-1.2A9.722,9.722,0,0,0,3.681.436,1.357,1.357,0,0,0,2.853,0C1.788-.045.6,1.376.39,1.716A2.762,2.762,0,0,0,.4,4.576c1.274,3.142,6.091,7.883,9.244,9.2a3.81,3.81,0,0,0,1.592.409,2.071,2.071,0,0,0,1.242-.389c.27-.156,1.749-1.4,1.711-2.5a1.377,1.377,0,0,0-.431-.827,9.79,9.79,0,0,0-2.287-1.692",
    fill: "#4165f6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePhoneIcon);
export default __webpack_public_path__ + "static/media/profile-phoneIcon.a98b6b4ac8c40474b37f40969d9e1560.svg";
export { ForwardRef as ReactComponent };